export const loadFavorites = (state) => state.favorites;
export const loadMovies = (state) => state.movies;
export const loadMovieDetails = (state) => state.movieDetails;
export const loadFavoriteMovies = (state) => state.favoriteMovies;